module.exports = __webpack_public_path__ + "static/img/27.f5eea6dd.png";